import { z } from "zod";
import { IInsightsExportState } from "../components/insights/InsightsExportData";

const validationSchema = () => z.object({
    email: z.string().min(1).email(),
});

export default () => (values: IInsightsExportState) => {
    const baseResult = validationSchema().safeParse(values);
    const errors: Record<string, string> = {};

    if (!baseResult.success) {
        baseResult.error.issues.forEach((issue) => {
            const path = issue.path.join('.');
            errors[path] = issue.message;
        });
    }

    if (!(values.areDealsSelected || values.areLeadsSelected || values.areLeaseCompsSelected || values.areSaleCompsSelected || values.areRecordedSalesSelected || values.areTenantsInMarketSelected))
        errors.areTenantsInMarketSelected = "At least one type must be selected";

    return errors;
};